import React, { useEffect } from 'react';
import Slider from "react-slick";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function SlickNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={`slick-arrow slick-next ${className}`} onClick={onClick}>
            <FiChevronRight />
        </div>
    );
}

function SlickPrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={`slick-arrow slick-prev ${className}`} onClick={onClick}>
            <FiChevronLeft />
        </div>
    );
}

const MvpServices = () => {
    const services = [
        {
            id: 1,
            title: "Cognitive AI Solutions",
            desc: "We build intelligent MVPs powered by AI to automate workflows, enhance decision-making, and deliver personalized user experiences.From chatbots to predictive analytics, we help you integrate smart capabilities from day one.",
            image: "/images/mvp/GAI.jpg"
        },
        {
            id: 2,
            title: "Platform & Product Engineering",
            desc: "We design and develop scalable MVPs tailored to your product vision, ensuring fast launch and future growth.Our team focuses on clean architecture and performance-driven development for long-term success.",
            image: "/images/mvp/product.jpg"
        },
        {
            id: 3,
            title: "IoT & Edge Technology",
            desc: "We create MVPs that connect devices, collect real-time data, and enable smarter operations at the edge.Our solutions ensure secure communication, low latency, and efficient data processing.",
            image: "/images/mvp/IOT.jpg"
        },
        {
            id: 4,
            title: "Enterprise Data & Integration",
            desc: "We build MVPs with strong data foundations, enabling seamless integration across systems and platforms.Our approach ensures smooth data flow, real-time insights, and scalable backend infrastructure.",
            image: "/images/mvp/image.png"
        },
        {
            id: 5,
            title: "Cloud & DevSecOps",
            desc: "We develop cloud-ready MVPs with secure, automated deployment pipelines for faster and safer releases.Our DevSecOps practices ensure scalability, reliability, and continuous delivery from the start.",
            image: "/images/mvp/cloud.png"
        },
    ];

    useEffect(() => {
        // react-slick clones slides in the DOM to power the infinite loop.
        // Hide those clones from assistive tech and crawlers so the same
        // service cards aren't read as duplicated content.
        const markClones = () => {
            document.querySelectorAll('.mvp-service-slider .slick-cloned').forEach((el) => {
                el.setAttribute('aria-hidden', 'true');
                el.querySelectorAll('a, button').forEach((focusable) => {
                    focusable.setAttribute('tabIndex', '-1');
                });
            });
        };
        markClones();
        const interval = setInterval(markClones, 1000);
        return () => clearInterval(interval);
    }, []);

    const slideSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SlickNextArrow />,
        prevArrow: <SlickPrevArrow />,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="section section-padding mvp-services-area">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h2 className="title mb-3 fw-bold" style={{ fontSize: "36px" }}>
                            Our MVP Development <span className="text-primary">Services</span>
                        </h2>
                        <p className="subtitle mb-5 text-muted" style={{ fontSize: "16px" }}>
                            End-to-end services to take your idea from whiteboard to working product — efficiently and affordably.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 pb-5">
                        <div className="mvp-service-slider">
                            <Slider {...slideSettings}>
                                {services.map((item) => (
                                    <div key={item.id} className="slick-slide-inner px-3 pb-3">
                                        <div className="mvp-svc-card bg-white h-100 d-flex flex-column">
                                            <div className="img-container">
                                                <img src={process.env.PUBLIC_URL + item.image} alt={item.title} className="w-100 img-fluid" />
                                            </div>
                                            <div className="content p-4 text-start flex-grow-1">
                                                <h4 className="title fs-5 fw-bold mb-3">{item.title}</h4>
                                                <p className="desc text-muted mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                                    {item.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MvpServices;
